// extracted by mini-css-extract-plugin
export default {"app":"app_app__C8ch5","piffleHolder":"app_piffleHolder__p4hN2"};